<template>
    <div class="avatar flex items-center jc-center bold" :style="styles" :title="value">
        {{ text }}
    </div>
</template>

<script>
    const providers = {
        laravel: {
            url: 'https://avatars.laravel.cloud/',
            transform: (value) => simpleHash(value),
            text: (value) => initials(value),
        },
    };

    const simpleHash = (value) => value.split('')
        .reduce((hash, char) => (hash << 5) - hash + (char.charCodeAt(0) | 0), 0)
        .toString(16);

    const initials = (value) => value.split(/\W/)
        .map(name => name[0])
        .slice(0, 3)
        .join('')
        .toUpperCase();

    export default {
        name: 'Avatar',

        props: {
            value: {
                type: String,
                required: true,
            },

            initials: {
                type: String,
                default: null,
            },

            seed: {
                type: String,
                default() {
                    return this.value;
                },
            },

            provider: {
                type: String,
                default: 'laravel',
                validator(provider) {
                    return !!providers[provider];
                },
            },
        },

        computed: {
            transformed() {
                return providers[this.provider].transform?.(this.seed) ?? this.seed;
            },

            text() {
                if ( this.initials ) {
                    return this.initials.slice(0, 3);
                }

                return providers[this.provider].text?.(this.value) ?? '';
            },

            styles() {
                return {
                    backgroundImage: `url(${providers[this.provider].url}${this.transformed})`,
                    backgroundSize: 'cover',
                };
            },
        },
    }
</script>
